const routesForm = {
  bindings: {
    selection: '<',
    onFormSubmit: '&',
    hasEdit: '<',
    isLocked: '<',
  },
  templateUrl:
    '/modules/pis-tool/routes/routes-form/routes-form.html',
  controller: 'RoutesFormController',
};

angular
  .module('pis-tool.module')
  .component('routesForm', routesForm);
